import axios from 'axios'
import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function getDepreciationByModel(modelId, versionId, year){  
    let results = ''
    try {
        results = await axios.get(`${DATAMASTER_ENDPOINT}/getDepreciationByModel/${modelId}/${versionId}/${year}`)
    } catch (error) {
        results = error.message
    }
    return results
}